<main>
    <div class="flex">
      <app-menu></app-menu>
      <aside>
        <img src="/assets/images/banner-rensa-training.jpg" alt="Rensa training banner" />
        <h4>Trainingen</h4>
        <div class="event-container">
          <app-list-item *ngFor="let item of items" [listItem]="item"></app-list-item>
        </div>
      </aside>
    </div>
  </main>
  <app-footer></app-footer>